// extracted by mini-css-extract-plugin
module.exports = {"macBar":"MacBar_macBar__3fLaf","left":"MacBar_left__24g8c","right":"MacBar_right__2s45i","middle":"MacBar_middle__3SwtC","dots":"MacBar_dots__14ke3"};